@let mode = tableColumnMode();
@let tableSettingsOpen = tableSettingsIsOpen();

<div class="smart-filter-right-panel">
  <div class="smart-filter-right-panel__toggle">
    <span class="smart-filter-right-panel__toggle-text">
      {{ 'load.list.smartFilter.statusLines' | translate }}
    </span>

    <fr8bot-ui-switch-toggle-field
      [checked]="isStatusLinesOn()"
      (checkedChange)="onStatusLinesToggle($event)"
    />
  </div>

  <div class="smart-filter-right-panel__columns">
    <span class="smart-filter-right-panel__columns-text">
      {{ 'load.list.smartFilter.columns' | translate }}:
    </span>

    <button
      class="smart-filter-right-panel__columns-label"
      [class.table-filter__container-right-columns-label--active]="tableSettingsOpen"
      (click)="onToggleTableSettings()"
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
    >
      @if (mode === 'compact') {
        {{ 'load.list.smartFilter.modeCompact' | translate }}
      } @else {
        {{ 'load.list.smartFilter.modeAdvanced' | translate }}
      }

      <span class="smart-filter-right-panel__columns-label-arrow">
        <fr8bot-ui-icon name="arrow-down-12" [size]="16" />
      </span>
    </button>
  </div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="tableSettingsOpen"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="dropdown-menu-backdrop"
    [cdkConnectedOverlayPanelClass]="['dropdown-menu', 'dropdown-menu--width-260']"
    (detach)="onDetach()"
    (backdropClick)="onBackdropClick()"
  >
    <button class="dropdown-item" (click)="compactModeSelected()">
      <span class="dropdown-item__checkmark">
        @if (mode === 'compact') {
          <fr8bot-ui-icon [name]="'checkmark-16'" [size]="16" />
        }
      </span>

      <span class="dropdown-item__icon">
        <fr8bot-ui-icon [name]="'collapse-16'" [size]="16" />
      </span>

      <span class="dropdown-item__text">
        <span class="dropdown-item__text-label">
          {{ 'load.list.smartFilter.modeCompact' | translate }}
        </span>
        <span class="dropdown-item__text-description">
          {{ 'load.list.smartFilter.modeCompactDescription' | translate }}
        </span>
      </span>
    </button>

    <button class="dropdown-item" (click)="fullModeSelected()">
      <div class="dropdown-item__checkmark">
        @if (mode === 'advanced') {
          <fr8bot-ui-icon name="checkmark-16" [size]="16" />
        }
      </div>

      <div class="dropdown-item__icon">
        <fr8bot-ui-icon name="expand-16" [size]="16" />
      </div>

      <div class="dropdown-item__text">
        <div class="dropdown-item__text-label">
          {{ 'load.list.smartFilter.modeCustom' | translate }}
        </div>
        <div class="dropdown-item__text-description">
          {{ 'load.list.smartFilter.customModeDescription' | translate }}
        </div>
      </div>
    </button>

    <div class="divider divider--size-large divider--color-black"></div>

    <div
      cdkDropList
      class="smart-filter-right-panel-settings scroll-primary"
      (cdkDropListDropped)="onColumnDrop($event)"
    >
      @for (column of columnOrder() | slice: 0 : -1; track trackByFn($index, column)) {
        @let configColumn = tableConfig()?.[column];
        @let isSelected = isColumnSelected(column);
        @let isItemDisabled = selectedColumns().length === 1 && isSelected;
        <button
          class="dropdown-item"
          cdkDrag
          [cdkDragDisabled]="!canChangeColumnsOrder()"
          [disabled]="isItemDisabled"
          (click)="toggleSelectedColumn(column)"
        >
          <span class="dropdown-item__checkmark">
            @if (isSelected) {
              <fr8bot-ui-icon
                [name]="'checkmark-16'"
                [size]="16"
                [class.tw:text-gray-4]="isItemDisabled"
              />
            }
          </span>

          <span class="dropdown-item__icon">
            @if (configColumn && configColumn.icon; as icon) {
              <fr8bot-ui-icon [name]="icon" [size]="16" />
            }
          </span>

          @if (configColumn) {
            <span class="dropdown-item__text">
              <span class="dropdown-item__text-label">
                {{ configColumn.name ?? '' | translate }}
              </span>
            </span>
          }

          <span cdkDragHandle class="dropdown-item__drag-handle">
            @if (canChangeColumnsOrder()) {
              <fr8bot-ui-icon [name]="'move-12'" [size]="16" />
            }
          </span>
        </button>
      }
    </div>
  </ng-template>
</div>
